import _styled from "@emotion/styled/base";
var _excluded = ["rotationDirection", "lineColor", "thickness", "size"],
    _excluded2 = ["rotationDirection", "lineColor", "thickness", "size", "unboundedLength"];

function cov_2k6xwkbgox() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Arrow.tsx";
  var hash = "edc04afe28c808af1bebb96349a5ecd4ae79d39d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Arrow.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 54
        },
        end: {
          line: 10,
          column: 61
        }
      },
      "1": {
        start: {
          line: 11,
          column: 26
        },
        end: {
          line: 11,
          column: 27
        }
      },
      "2": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 12,
          column: 29
        }
      },
      "3": {
        start: {
          line: 13,
          column: 29
        },
        end: {
          line: 13,
          column: 53
        }
      },
      "4": {
        start: {
          line: 15,
          column: 56
        },
        end: {
          line: 15,
          column: 73
        }
      },
      "5": {
        start: {
          line: 16,
          column: 26
        },
        end: {
          line: 16,
          column: 52
        }
      },
      "6": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 54
        }
      },
      "7": {
        start: {
          line: 27,
          column: 25
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "8": {
        start: {
          line: 28,
          column: 33
        },
        end: {
          line: 28,
          column: 47
        }
      },
      "9": {
        start: {
          line: 29,
          column: 41
        },
        end: {
          line: 29,
          column: 55
        }
      },
      "10": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 37,
          column: 23
        }
      },
      "11": {
        start: {
          line: 33,
          column: 3
        },
        end: {
          line: 37,
          column: 22
        }
      },
      "12": {
        start: {
          line: 39,
          column: 22
        },
        end: {
          line: 44,
          column: 26
        }
      },
      "13": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 44,
          column: 26
        }
      },
      "14": {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 51,
          column: 22
        }
      },
      "15": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 51,
          column: 22
        }
      },
      "16": {
        start: {
          line: 53,
          column: 18
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "17": {
        start: {
          line: 54,
          column: 21
        },
        end: {
          line: 59,
          column: 25
        }
      },
      "18": {
        start: {
          line: 55,
          column: 5
        },
        end: {
          line: 59,
          column: 24
        }
      },
      "19": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 62,
          column: 4
        }
      },
      "20": {
        start: {
          line: 66,
          column: 66
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "21": {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 81,
          column: 8
        }
      },
      "22": {
        start: {
          line: 85,
          column: 51
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "23": {
        start: {
          line: 93,
          column: 23
        },
        end: {
          line: 93,
          column: 72
        }
      },
      "24": {
        start: {
          line: 94,
          column: 42
        },
        end: {
          line: 94,
          column: 84
        }
      },
      "25": {
        start: {
          line: 96,
          column: 28
        },
        end: {
          line: 106,
          column: 3
        }
      },
      "26": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 105,
          column: 11
        }
      },
      "27": {
        start: {
          line: 108,
          column: 33
        },
        end: {
          line: 116,
          column: 3
        }
      },
      "28": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 115,
          column: 6
        }
      },
      "29": {
        start: {
          line: 118,
          column: 20
        },
        end: {
          line: 125,
          column: 3
        }
      },
      "30": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 124,
          column: 6
        }
      },
      "31": {
        start: {
          line: 127,
          column: 2
        },
        end: {
          line: 137,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 23
          }
        },
        loc: {
          start: {
            line: 28,
            column: 33
          },
          end: {
            line: 28,
            column: 47
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 29,
            column: 31
          }
        },
        loc: {
          start: {
            line: 29,
            column: 41
          },
          end: {
            line: 29,
            column: 55
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 20
          },
          end: {
            line: 32,
            column: 21
          }
        },
        loc: {
          start: {
            line: 33,
            column: 3
          },
          end: {
            line: 37,
            column: 22
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 22
          },
          end: {
            line: 39,
            column: 23
          }
        },
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 44,
            column: 26
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 21
          },
          end: {
            line: 46,
            column: 22
          }
        },
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 51,
            column: 22
          }
        },
        line: 47
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 53,
            column: 18
          },
          end: {
            line: 53,
            column: 19
          }
        },
        loc: {
          start: {
            line: 53,
            column: 52
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 53
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 22
          }
        },
        loc: {
          start: {
            line: 55,
            column: 5
          },
          end: {
            line: 59,
            column: 24
          }
        },
        line: 55
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 66,
            column: 66
          },
          end: {
            line: 66,
            column: 67
          }
        },
        loc: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 81,
            column: 8
          }
        },
        line: 73
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 85,
            column: 51
          },
          end: {
            line: 85,
            column: 52
          }
        },
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 138,
            column: 1
          }
        },
        line: 92
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 96,
            column: 28
          },
          end: {
            line: 96,
            column: 29
          }
        },
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 105,
            column: 11
          }
        },
        line: 97
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 108,
            column: 33
          },
          end: {
            line: 108,
            column: 34
          }
        },
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 115,
            column: 6
          }
        },
        line: 109
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 118,
            column: 21
          }
        },
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 124,
            column: 6
          }
        },
        line: 119
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 3
          },
          end: {
            line: 37,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 3
          },
          end: {
            line: 37,
            column: 14
          }
        }, {
          start: {
            line: 37,
            column: 18
          },
          end: {
            line: 37,
            column: 22
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 72
          },
          end: {
            line: 39,
            column: 95
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 39,
            column: 90
          },
          end: {
            line: 39,
            column: 95
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 44,
            column: 26
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 22
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 26
          }
        }],
        line: 40
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 26
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 12
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 26
          }
        }],
        line: 42
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 71
          },
          end: {
            line: 46,
            column: 94
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 46,
            column: 89
          },
          end: {
            line: 46,
            column: 94
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 51,
            column: 22
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 50,
            column: 28
          }
        }, {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 22
          }
        }],
        line: 47
      },
      "6": {
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 50,
            column: 28
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 49,
            column: 14
          }
        }, {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 28
          }
        }],
        line: 48
      },
      "7": {
        loc: {
          start: {
            line: 55,
            column: 5
          },
          end: {
            line: 59,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 5
          },
          end: {
            line: 59,
            column: 16
          }
        }, {
          start: {
            line: 59,
            column: 20
          },
          end: {
            line: 59,
            column: 24
          }
        }],
        line: 55
      },
      "8": {
        loc: {
          start: {
            line: 61,
            column: 20
          },
          end: {
            line: 61,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 64
          },
          end: {
            line: 61,
            column: 81
          }
        }, {
          start: {
            line: 61,
            column: 84
          },
          end: {
            line: 61,
            column: 99
          }
        }],
        line: 61
      },
      "9": {
        loc: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 67,
            column: 22
          },
          end: {
            line: 67,
            column: 48
          }
        }],
        line: 67
      },
      "10": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 14
          },
          end: {
            line: 68,
            column: 23
          }
        }],
        line: 68
      },
      "11": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 69,
            column: 14
          },
          end: {
            line: 69,
            column: 31
          }
        }],
        line: 69
      },
      "12": {
        loc: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 27
          }
        }],
        line: 70
      },
      "13": {
        loc: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 86,
            column: 22
          },
          end: {
            line: 86,
            column: 48
          }
        }],
        line: 86
      },
      "14": {
        loc: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 87,
            column: 14
          },
          end: {
            line: 87,
            column: 23
          }
        }],
        line: 87
      },
      "15": {
        loc: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 14
          },
          end: {
            line: 88,
            column: 31
          }
        }],
        line: 88
      },
      "16": {
        loc: {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 34
          }
        }],
        line: 89
      },
      "17": {
        loc: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 90,
            column: 20
          },
          end: {
            line: 90,
            column: 25
          }
        }],
        line: 90
      },
      "18": {
        loc: {
          start: {
            line: 102,
            column: 21
          },
          end: {
            line: 102,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 36
          },
          end: {
            line: 102,
            column: 41
          }
        }, {
          start: {
            line: 102,
            column: 44
          },
          end: {
            line: 102,
            column: 52
          }
        }],
        line: 102
      },
      "19": {
        loc: {
          start: {
            line: 127,
            column: 9
          },
          end: {
            line: 137,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 131,
            column: 14
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 136,
            column: 14
          }
        }],
        line: 127
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0],
      "11": [0],
      "12": [0],
      "13": [0],
      "14": [0],
      "15": [0],
      "16": [0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "edc04afe28c808af1bebb96349a5ecd4ae79d39d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2k6xwkbgox = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2k6xwkbgox();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Box, Flex } from '../core';
import { colors } from '../theme/eero';
var DEFAULT_ROTATION_DIRECTION = (cov_2k6xwkbgox().s[0]++, 'right');
var DEFAULT_THICKNESS = (cov_2k6xwkbgox().s[1]++, 2);
var DEFAULT_ARROW_SIZE = (cov_2k6xwkbgox().s[2]++, 10);
var DEFAULT_ARROW_LENGTH = (cov_2k6xwkbgox().s[3]++, ['35px', '35px', '60px']);
var HORIZONTAL_DIRECTIONS = (cov_2k6xwkbgox().s[4]++, ['left', 'right']);
var HORIZONTAL_MARGIN = (cov_2k6xwkbgox().s[5]++, "-".concat(DEFAULT_ARROW_SIZE, "px"));
var VERTICAL_MARGIN = (cov_2k6xwkbgox().s[6]++, "-".concat(DEFAULT_ARROW_SIZE * 2, "px"));
var RotatedArrowhead = (cov_2k6xwkbgox().s[7]++, /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "evx4x310"
} : {
  target: "evx4x310",
  label: "RotatedArrowhead"
})("transform:rotate(", function (props) {
  cov_2k6xwkbgox().f[0]++;
  cov_2k6xwkbgox().s[8]++;
  return props.rotation;
}, "deg);-webkit-transform:rotate(", function (props) {
  cov_2k6xwkbgox().f[1]++;
  cov_2k6xwkbgox().s[9]++;
  return props.rotation;
}, "deg);" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZXByZWNhdGVkL1VOU0FGRV9BcnJvdy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEIwRCIsImZpbGUiOiIuLi8uLi9zcmMvZGVwcmVjYXRlZC9VTlNBRkVfQXJyb3cudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgQm94LCBGbGV4LCBCb3hQcm9wcyB9IGZyb20gJy4uL2NvcmUnO1xuaW1wb3J0IHsgY29sb3JzIH0gZnJvbSAnLi4vdGhlbWUvZWVybyc7XG5pbXBvcnQgeyBDb2xvclNjaGVtZSB9IGZyb20gJy4uL3N5c3RlbS90aGVtZSc7XG5cbnR5cGUgUm90YXRpb25EaXJlY3Rpb24gPSAnbGVmdCcgfCAncmlnaHQnIHwgJ3VwJyB8ICdkb3duJztcblxuY29uc3QgREVGQVVMVF9ST1RBVElPTl9ESVJFQ1RJT046IFJvdGF0aW9uRGlyZWN0aW9uID0gJ3JpZ2h0JztcbmNvbnN0IERFRkFVTFRfVEhJQ0tORVNTID0gMjtcbmNvbnN0IERFRkFVTFRfQVJST1dfU0laRSA9IDEwO1xuY29uc3QgREVGQVVMVF9BUlJPV19MRU5HVEggPSBbJzM1cHgnLCAnMzVweCcsICc2MHB4J107XG5cbmNvbnN0IEhPUklaT05UQUxfRElSRUNUSU9OUzogQXJyYXk8Um90YXRpb25EaXJlY3Rpb24+ID0gWydsZWZ0JywgJ3JpZ2h0J107XG5jb25zdCBIT1JJWk9OVEFMX01BUkdJTiA9IGAtJHtERUZBVUxUX0FSUk9XX1NJWkV9cHhgO1xuY29uc3QgVkVSVElDQUxfTUFSR0lOID0gYC0ke0RFRkFVTFRfQVJST1dfU0laRSAqIDJ9cHhgO1xuXG5pbnRlcmZhY2UgSUFycm93UHJvcHMge1xuICByb3RhdGlvbkRpcmVjdGlvbj86IFJvdGF0aW9uRGlyZWN0aW9uO1xuICBsaW5lQ29sb3I/OiBDb2xvclNjaGVtZTtcbiAgc2l6ZT86IG51bWJlcjtcbiAgdGhpY2tuZXNzPzogbnVtYmVyO1xuICB1bmJvdW5kZWRMZW5ndGg/OiBib29sZWFuO1xufVxuXG5jb25zdCBSb3RhdGVkQXJyb3doZWFkID0gc3R5bGVkKEJveCk8eyByb3RhdGlvbjogbnVtYmVyIH0+YFxuICB0cmFuc2Zvcm06IHJvdGF0ZSgkeyhwcm9wcykgPT4gcHJvcHMucm90YXRpb259ZGVnKTtcbiAgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgkeyhwcm9wcykgPT4gcHJvcHMucm90YXRpb259ZGVnKTtcbmA7XG5cbmNvbnN0IHJvdGF0ZUFycm93ID0gKGRpcmVjdGlvbjogUm90YXRpb25EaXJlY3Rpb24pID0+XG4gICh7XG4gICAgcmlnaHQ6IC00NSxcbiAgICBsZWZ0OiAxMzUsXG4gICAgZG93bjogNDUsXG4gIH1bZGlyZWN0aW9uXSB8fCAtMTM1KTtcblxuY29uc3QgZ2V0Qm9keUhlaWdodCA9IChkaXJlY3Rpb246IFJvdGF0aW9uRGlyZWN0aW9uLCB0aGlja25lc3M6IG51bWJlciwgdW5ib3VuZGVkTGVuZ3RoID0gZmFsc2UpID0+XG4gIEhPUklaT05UQUxfRElSRUNUSU9OUy5pbmNsdWRlcyhkaXJlY3Rpb24pXG4gICAgPyBgJHt0aGlja25lc3N9cHhgXG4gICAgOiB1bmJvdW5kZWRMZW5ndGhcbiAgICA/ICcxMDAlJ1xuICAgIDogREVGQVVMVF9BUlJPV19MRU5HVEg7XG5cbmNvbnN0IGdldEJvZHlXaWR0aCA9IChkaXJlY3Rpb246IFJvdGF0aW9uRGlyZWN0aW9uLCB0aGlja25lc3M6IG51bWJlciwgdW5ib3VuZGVkTGVuZ3RoID0gZmFsc2UpID0+XG4gIEhPUklaT05UQUxfRElSRUNUSU9OUy5pbmNsdWRlcyhkaXJlY3Rpb24pXG4gICAgPyB1bmJvdW5kZWRMZW5ndGhcbiAgICAgID8gJzEwMCUnXG4gICAgICA6IERFRkFVTFRfQVJST1dfTEVOR1RIXG4gICAgOiBgJHt0aGlja25lc3N9cHhgO1xuXG5jb25zdCBnZXRNYXJnaW4gPSAoZGlyZWN0aW9uOiBSb3RhdGlvbkRpcmVjdGlvbikgPT4ge1xuICBjb25zdCBtYXJnaW5UeXBlID0gKCkgPT5cbiAgICAoe1xuICAgICAgcmlnaHQ6ICdtbCcsXG4gICAgICBsZWZ0OiAnbXInLFxuICAgICAgZG93bjogJ210JyxcbiAgICB9W2RpcmVjdGlvbl0gfHwgJ21iJyk7XG4gIHJldHVybiB7XG4gICAgW21hcmdpblR5cGUoKV06IEhPUklaT05UQUxfRElSRUNUSU9OUy5pbmNsdWRlcyhkaXJlY3Rpb24pID8gSE9SSVpPTlRBTF9NQVJHSU4gOiBWRVJUSUNBTF9NQVJHSU4sXG4gIH07XG59O1xuXG4vKiogQGRlcHJlY2F0ZWQgVXNlIHRoZSBBcnJvd2hlYWQgZnJvbSBTcHJpdGVzaGVldCAqL1xuZXhwb3J0IGNvbnN0IFVOU0FGRV9BcnJvd2hlYWQ6IFJlYWN0LkZDPElBcnJvd1Byb3BzICYgQm94UHJvcHM+ID0gKHtcbiAgcm90YXRpb25EaXJlY3Rpb24gPSBERUZBVUxUX1JPVEFUSU9OX0RJUkVDVElPTixcbiAgbGluZUNvbG9yID0gJ2JyYW5kNTAnLFxuICB0aGlja25lc3MgPSBERUZBVUxUX1RISUNLTkVTUyxcbiAgc2l6ZSA9IERFRkFVTFRfQVJST1dfU0laRSxcbiAgLi4ucmVzdFxufSkgPT4gKFxuICA8Qm94IHsuLi5yZXN0fT5cbiAgICA8Um90YXRlZEFycm93aGVhZFxuICAgICAgYm9yZGVyPXtgc29saWQgJHtjb2xvcnNbbGluZUNvbG9yXX1gfVxuICAgICAgYm9yZGVyV2lkdGg9e2AwICR7dGhpY2tuZXNzfXB4ICR7dGhpY2tuZXNzfXB4IDBgfVxuICAgICAgZGlzcGxheT1cImlubGluZS1ibG9ja1wiXG4gICAgICBwYWRkaW5nPXtgJHtzaXplfXB4YH1cbiAgICAgIHJvdGF0aW9uPXtyb3RhdGVBcnJvdyhyb3RhdGlvbkRpcmVjdGlvbil9XG4gICAgLz5cbiAgPC9Cb3g+XG4pO1xuXG4vKiogQGRlcHJlY2F0ZWQgKi9cbmV4cG9ydCBjb25zdCBVTlNBRkVfQXJyb3c6IFJlYWN0LkZDPElBcnJvd1Byb3BzPiA9ICh7XG4gIHJvdGF0aW9uRGlyZWN0aW9uID0gREVGQVVMVF9ST1RBVElPTl9ESVJFQ1RJT04sXG4gIGxpbmVDb2xvciA9ICdicmFuZDUwJyxcbiAgdGhpY2tuZXNzID0gREVGQVVMVF9USElDS05FU1MsXG4gIHNpemU6IF9zaXplID0gREVGQVVMVF9BUlJPV19TSVpFLFxuICB1bmJvdW5kZWRMZW5ndGggPSBmYWxzZSxcbiAgLi4ucmVzdFxufSkgPT4ge1xuICBjb25zdCBpc0hvcml6b250YWwgPSBIT1JJWk9OVEFMX0RJUkVDVElPTlMuaW5jbHVkZXMocm90YXRpb25EaXJlY3Rpb24pO1xuICBjb25zdCBzaG91bGRBcnJvd2hlYWRBcHBlYXJCZWZvcmVCb2R5ID0gWydsZWZ0JywgJ3VwJ10uaW5jbHVkZXMocm90YXRpb25EaXJlY3Rpb24pO1xuXG4gIGNvbnN0IFdyYXBwZXI6IFJlYWN0LkZDID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICAgIDxGbGV4XG4gICAgICBhbGlnbkl0ZW1zPVwiY2VudGVyXCJcbiAgICAgIGhlaWdodD1cIjEwMCVcIlxuICAgICAganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIlxuICAgICAgbXg9XCIxMHB4XCJcbiAgICAgIGZsZXhEaXJlY3Rpb249e2lzSG9yaXpvbnRhbCA/ICdyb3cnIDogJ2NvbHVtbid9XG4gICAgPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvRmxleD5cbiAgKTtcblxuICBjb25zdCBQYXJhbWV0ZXJpemVkQXJyb3doZWFkID0gKCkgPT4gKFxuICAgIDxVTlNBRkVfQXJyb3doZWFkXG4gICAgICB7Li4uZ2V0TWFyZ2luKHJvdGF0aW9uRGlyZWN0aW9uKX1cbiAgICAgIHJvdGF0aW9uRGlyZWN0aW9uPXtyb3RhdGlvbkRpcmVjdGlvbn1cbiAgICAgIHNpemU9e3RoaWNrbmVzcyAqIDJ9XG4gICAgICBsaW5lQ29sb3I9e2xpbmVDb2xvcn1cbiAgICAgIHsuLi5yZXN0fVxuICAgIC8+XG4gICk7XG5cbiAgY29uc3QgQXJyb3dCb2R5ID0gKCkgPT4gKFxuICAgIDxCb3hcbiAgICAgIGhlaWdodD17Z2V0Qm9keUhlaWdodChyb3RhdGlvbkRpcmVjdGlvbiwgdGhpY2tuZXNzLCB1bmJvdW5kZWRMZW5ndGgpfVxuICAgICAgd2lkdGg9e2dldEJvZHlXaWR0aChyb3RhdGlvbkRpcmVjdGlvbiwgdGhpY2tuZXNzLCB1bmJvdW5kZWRMZW5ndGgpfVxuICAgICAgYmFja2dyb3VuZD17bGluZUNvbG9yfVxuICAgICAgbXQ9e2AtJHt0aGlja25lc3MgKiAyfXB4YH1cbiAgICAvPlxuICApO1xuXG4gIHJldHVybiBzaG91bGRBcnJvd2hlYWRBcHBlYXJCZWZvcmVCb2R5ID8gKFxuICAgIDxXcmFwcGVyPlxuICAgICAgPFBhcmFtZXRlcml6ZWRBcnJvd2hlYWQgLz5cbiAgICAgIDxBcnJvd0JvZHkgLz5cbiAgICA8L1dyYXBwZXI+XG4gICkgOiAoXG4gICAgPFdyYXBwZXI+XG4gICAgICA8QXJyb3dCb2R5IC8+XG4gICAgICA8UGFyYW1ldGVyaXplZEFycm93aGVhZCAvPlxuICAgIDwvV3JhcHBlcj5cbiAgKTtcbn07XG4iXX0= */")));
cov_2k6xwkbgox().s[10]++;

var rotateArrow = function rotateArrow(direction) {
  cov_2k6xwkbgox().f[2]++;
  cov_2k6xwkbgox().s[11]++;
  return (cov_2k6xwkbgox().b[0][0]++, {
    right: -45,
    left: 135,
    down: 45
  }[direction]) || (cov_2k6xwkbgox().b[0][1]++, -135);
};

cov_2k6xwkbgox().s[12]++;

var getBodyHeight = function getBodyHeight(direction, thickness) {
  var unboundedLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_2k6xwkbgox().b[1][0]++, false);
  cov_2k6xwkbgox().f[3]++;
  cov_2k6xwkbgox().s[13]++;
  return HORIZONTAL_DIRECTIONS.includes(direction) ? (cov_2k6xwkbgox().b[2][0]++, "".concat(thickness, "px")) : (cov_2k6xwkbgox().b[2][1]++, unboundedLength ? (cov_2k6xwkbgox().b[3][0]++, '100%') : (cov_2k6xwkbgox().b[3][1]++, DEFAULT_ARROW_LENGTH));
};

cov_2k6xwkbgox().s[14]++;

var getBodyWidth = function getBodyWidth(direction, thickness) {
  var unboundedLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_2k6xwkbgox().b[4][0]++, false);
  cov_2k6xwkbgox().f[4]++;
  cov_2k6xwkbgox().s[15]++;
  return HORIZONTAL_DIRECTIONS.includes(direction) ? (cov_2k6xwkbgox().b[5][0]++, unboundedLength ? (cov_2k6xwkbgox().b[6][0]++, '100%') : (cov_2k6xwkbgox().b[6][1]++, DEFAULT_ARROW_LENGTH)) : (cov_2k6xwkbgox().b[5][1]++, "".concat(thickness, "px"));
};

cov_2k6xwkbgox().s[16]++;

var getMargin = function getMargin(direction) {
  cov_2k6xwkbgox().f[5]++;
  cov_2k6xwkbgox().s[17]++;

  var marginType = function marginType() {
    cov_2k6xwkbgox().f[6]++;
    cov_2k6xwkbgox().s[18]++;
    return (cov_2k6xwkbgox().b[7][0]++, {
      right: 'ml',
      left: 'mr',
      down: 'mt'
    }[direction]) || (cov_2k6xwkbgox().b[7][1]++, 'mb');
  };

  cov_2k6xwkbgox().s[19]++;
  return _defineProperty({}, marginType(), HORIZONTAL_DIRECTIONS.includes(direction) ? (cov_2k6xwkbgox().b[8][0]++, HORIZONTAL_MARGIN) : (cov_2k6xwkbgox().b[8][1]++, VERTICAL_MARGIN));
};
/** @deprecated Use the Arrowhead from Spritesheet */


cov_2k6xwkbgox().s[20]++;
export var UNSAFE_Arrowhead = function UNSAFE_Arrowhead(_ref2) {
  var _ref2$rotationDirecti = _ref2.rotationDirection,
      rotationDirection = _ref2$rotationDirecti === void 0 ? (cov_2k6xwkbgox().b[9][0]++, DEFAULT_ROTATION_DIRECTION) : _ref2$rotationDirecti,
      _ref2$lineColor = _ref2.lineColor,
      lineColor = _ref2$lineColor === void 0 ? (cov_2k6xwkbgox().b[10][0]++, 'brand50') : _ref2$lineColor,
      _ref2$thickness = _ref2.thickness,
      thickness = _ref2$thickness === void 0 ? (cov_2k6xwkbgox().b[11][0]++, DEFAULT_THICKNESS) : _ref2$thickness,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? (cov_2k6xwkbgox().b[12][0]++, DEFAULT_ARROW_SIZE) : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded);

  cov_2k6xwkbgox().f[7]++;
  cov_2k6xwkbgox().s[21]++;
  return /*#__PURE__*/React.createElement(Box, rest, /*#__PURE__*/React.createElement(RotatedArrowhead, {
    border: "solid ".concat(colors[lineColor]),
    borderWidth: "0 ".concat(thickness, "px ").concat(thickness, "px 0"),
    display: "inline-block",
    padding: "".concat(size, "px"),
    rotation: rotateArrow(rotationDirection)
  }));
};
/** @deprecated */

cov_2k6xwkbgox().s[22]++;
export var UNSAFE_Arrow = function UNSAFE_Arrow(_ref3) {
  var _ref3$rotationDirecti = _ref3.rotationDirection,
      rotationDirection = _ref3$rotationDirecti === void 0 ? (cov_2k6xwkbgox().b[13][0]++, DEFAULT_ROTATION_DIRECTION) : _ref3$rotationDirecti,
      _ref3$lineColor = _ref3.lineColor,
      lineColor = _ref3$lineColor === void 0 ? (cov_2k6xwkbgox().b[14][0]++, 'brand50') : _ref3$lineColor,
      _ref3$thickness = _ref3.thickness,
      thickness = _ref3$thickness === void 0 ? (cov_2k6xwkbgox().b[15][0]++, DEFAULT_THICKNESS) : _ref3$thickness,
      _ref3$size = _ref3.size,
      _size = _ref3$size === void 0 ? (cov_2k6xwkbgox().b[16][0]++, DEFAULT_ARROW_SIZE) : _ref3$size,
      _ref3$unboundedLength = _ref3.unboundedLength,
      unboundedLength = _ref3$unboundedLength === void 0 ? (cov_2k6xwkbgox().b[17][0]++, false) : _ref3$unboundedLength,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  cov_2k6xwkbgox().f[8]++;
  var isHorizontal = (cov_2k6xwkbgox().s[23]++, HORIZONTAL_DIRECTIONS.includes(rotationDirection));
  var shouldArrowheadAppearBeforeBody = (cov_2k6xwkbgox().s[24]++, ['left', 'up'].includes(rotationDirection));
  cov_2k6xwkbgox().s[25]++;

  var Wrapper = function Wrapper(_ref4) {
    var children = _ref4.children;
    cov_2k6xwkbgox().f[9]++;
    cov_2k6xwkbgox().s[26]++;
    return /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      height: "100%",
      justifyContent: "center",
      mx: "10px",
      flexDirection: isHorizontal ? (cov_2k6xwkbgox().b[18][0]++, 'row') : (cov_2k6xwkbgox().b[18][1]++, 'column')
    }, children);
  };

  cov_2k6xwkbgox().s[27]++;

  var ParameterizedArrowhead = function ParameterizedArrowhead() {
    cov_2k6xwkbgox().f[10]++;
    cov_2k6xwkbgox().s[28]++;
    return /*#__PURE__*/React.createElement(UNSAFE_Arrowhead, _extends({}, getMargin(rotationDirection), {
      rotationDirection: rotationDirection,
      size: thickness * 2,
      lineColor: lineColor
    }, rest));
  };

  cov_2k6xwkbgox().s[29]++;

  var ArrowBody = function ArrowBody() {
    cov_2k6xwkbgox().f[11]++;
    cov_2k6xwkbgox().s[30]++;
    return /*#__PURE__*/React.createElement(Box, {
      height: getBodyHeight(rotationDirection, thickness, unboundedLength),
      width: getBodyWidth(rotationDirection, thickness, unboundedLength),
      background: lineColor,
      mt: "-".concat(thickness * 2, "px")
    });
  };

  cov_2k6xwkbgox().s[31]++;
  return shouldArrowheadAppearBeforeBody ? (cov_2k6xwkbgox().b[19][0]++, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ParameterizedArrowhead, null), /*#__PURE__*/React.createElement(ArrowBody, null))) : (cov_2k6xwkbgox().b[19][1]++, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ArrowBody, null), /*#__PURE__*/React.createElement(ParameterizedArrowhead, null)));
};